import { axiosPost } from "./apiClient";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/security`;

const verifyDashboardCardsPassword = async (password) => {
  return await axiosPost(`${BASE_URL}/dashboard-cards/verify`, { password });
};

const setDashboardCardsPassword = async ({ userId, enable, password }) => {
  return await axiosPost(`${BASE_URL}/dashboard-cards/set`, { userId, enable, password });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { verifyDashboardCardsPassword,setDashboardCardsPassword };
